import VerticalDivider from './VerticalDivider';

export {
  VerticalDivider
}



// WEBPACK FOOTER //
// ./src/components/Dividers/index.js